import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/my/classes/$classId")({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/my/classes/$classId"!</div>;
}
